import { getInitiativeStatuses } from '@api';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesStatusesGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreInitiativesStatuses',
	receive: true,
	request: false,
	requestHandler: getInitiativeStatuses,
	yieldType: SagaYieldType.Latest
});
